import { ILEGGELSE_SERVICE_BASE_URL } from "../config.ts";

export const GET_MOTTAKERTYPER_URL = `${ILEGGELSE_SERVICE_BASE_URL}/mottakertyper`;
